//메인화면 메뉴리스트
import React, { useState, useEffect } from "react";

//MUI
import {  Button, Checkbox, InputAdornment, MenuItem, TextField } from '@mui/material';
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { theme } from '../../assets/themes';
import USelectBox from "../../components/mui/USelectBox";

import { API } from "../../config";
import { fni18n } from "../../services/commonService";
import {
    getAPI
} from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";
const userLoginId = AuthenticationService.getLoggedInUserID();

const UserModify = (props) => {
    const [branchs, setBranch]=useState([]);
    const [groups, setGroups] = useState([]);
    const [storeNo, setStoreNo] = useState([]);
    const [select, setSelect] = useState({
        storeCd : "N/A",
        brandCd : "N/A",
    });
    const [total, setTotal] = useState([]);
    const modify = props.data;
    const onParamsChange = props.onParamsChange;
    const onStoreChage = props.onStoreChage
    const onCheckboxChange = props.onCheckboxChange;
    const onPwdChange =props.onPwdChange;
    const setErrorMsg = props.setErrorMsg;
    const handleErrorOpen = props.handleErrorOpen;
    const onItemChage = async(e) =>{
        const {name, value} = e.target;
        setSelect({
            ...select,
            [name] :value,
        })
        if(name=='storeCd'){
            await loadComboBoxStoreNo(value);
        }
        onParamsChange(e);
    }
    const onGroupChage = async (e) => {
        const { name, value } = e.target;
        let data = ({
            brandCd : modify.brandCd,
            grpNm : value,
        });
        await getAPI(API.OPER.TILL, data).then((res) =>{
            if (typeof res.data.result[0] === "undefined") {
                setTotal({
                    dayLimtAmt : 0,
                    tranctAmt : 0,
                })
            }
            else{
                setTotal({
                    dayLimtAmt : res.data.result[0].dayLimtAmt,
                    tranctAmt : res.data.result[0].tranctAmt,
                })
            }
        })
        onParamsChange(e);
    }
    const onBrandChage = async (e) => {
        const { name, value } = e.target;
        console.log(e);
        let data = ({
            brandCd : value,
            grpNm : modify.grpNm,
        });
        await getAPI(API.OPER.TILL, data).then((res) =>{
            if (typeof res.data.result[0] === "undefined") {
                setTotal({
                    dayLimtAmt : 0,
                    tranctAmt : 0,
                })
            }
            else{
                setTotal({
                    dayLimtAmt : res.data.result[0].dayLimtAmt,
                    tranctAmt : res.data.result[0].tranctAmt,
                })
            }
        })
        onParamsChange(e);
    }
    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
        try {
            await loadComboBoxBranch();
            await loadComboBoxGroup();
            setTotal({
                dayLimtAmt : Number(modify.tillTotal*modify.outLimtCnt).toLocaleString("en-US"),
                tranctAmt : Number(modify.tillTotal).toLocaleString("en-US"),
            })
        } catch (e) {
        }
        };
        const e = {
            target: { value : modify.grpNm}
        }
        getLoadData();
    }, []);
    useEffect(() => {
        let e;
        if(select.storeCd!="N/A" && !modify.create){
            if(select.brandCd!="N/A" && !modify.create){
                e = {
                    storeCd :{
                        name:'storeCd',
                        value:select.storeCd,
                    },
                    brandCd :{
                        name:'brandCd',
                        value:select.brandCd,
                    }
                }
            }else if(!modify.create){
                e = {
                    storeCd :{
                        name:'storeCd',
                        value:select.storeCd,
                    },
                    brandCd :{
                        name:'brandCd',
                        value:'',
                    }
                }
            }
        }else if(!modify.create){
            e = {
                storeCd :{
                    name:'storeCd',
                    value:'',
                },
                brandCd :{
                    name:'brandCd',
                    value:'',
                }
            }
        }else {
            e = {
                storeCd :{
                    name:'storeCd',
                    value:modify.storeCd,
                },
                brandCd :{
                    name:'brandCd',
                    value:modify.brandCd,
                }
            }
        }
        onStoreChage(e)
    }, [select]);
    // 콤보박스 데이터
    const loadComboBoxBranch = async () => {
        try{
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId });
            const _inputData = res.data.result.map((m) => ({
                    cd: m.storeCd,
                    name: m.storeNm
                })
            );
            setBranch(_inputData );
            if (_inputData.length > 0){
                await loadComboBoxStoreNo(_inputData[0].cd);
            }
        }catch(e){
            console.error(e.message);
        }
    };

    const loadComboBoxGroup = async () => {
        try{
            const res = await getAPI(API.COMMON.USER_GROUP);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.grpCd,
                    name: m.grpNm,
                    amt: m.tillTotal,
                    cnt: m.outLimtCnt
                })
            );
            setGroups(_inputData );
        }catch(e){
            console.error(e.message);
        }
    }; 

    const loadComboBoxStoreNo = async (branch) => {
        try{
            const res = await getAPI(API.COMMON.BRAND, { userId: userLoginId, branch: branch, });
            const _inputData = res.data.result.map((m) => ({
                    cd: m.brandCd,
                    name: m.brandNm,
                })
            );
            if (_inputData.length > 0) {
                setSelect({
                    ...select,
                    ['brandCd'] : _inputData[0].cd,
                    ['storeCd'] : branch,
                })
            } else {
                setSelect({
                    ...select,
                    ['brandCd'] : "N/A",
                    ['storeCd'] : branch,
                })
            }
            setStoreNo(_inputData );
        }catch(e){
            console.error(e.message);
        }
    }
    return(
        <div className="pop-container">
            {/* 상단메뉴명 */}
            <div className="header">
                {fni18n('초기 비밀번호는 재설정만 가능하며, 로그인 시 변경할 수 있습니다')}
            </div>
            <div className="contents">
            <TableContainer className="table-container">
                <Table className="table" size="small">
                    <TableBody>
                    <TableRow>
                    <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                        <TableCell className="table-cell">
                            {modify.create &&
                                <TextField
                                fullWidth
                                size="small"
                                name="storeNm"
                                value={modify.storeNm}
                                disabled
                                InputProps={{
                                    readOnly: true,
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                            }
                            {!modify.create &&
                                <FormControl size="small" fullWidth={true}>
                                {/* <Select
                                    name="storeCd"
                                    value={modify.storeCd}
                                    onChange={onItemChage}
                                >
                                    {branchs.map((map)=>(
                                        <MenuItem key={map.cd} value={map.cd}>
                                            {map.name}
                                        </MenuItem>
                                    ))}
                                </Select> */}
                                <USelectBox id="storeCd" name="storeCd" items={branchs} onItemChange={onItemChage} defaultValue={select.storeCd}/>
                                </FormControl>
                            }
                            
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('브랜드')}</TableCell>
                        <TableCell className="table-cell">
                            {modify.create &&
                                <TextField
                                fullWidth
                                size="small"
                                name="brandNm"
                                value={modify.brandNm}
                                disabled
                                InputProps={{
                                    readOnly: true,
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                            }
                            {!modify.create &&
                            <FormControl size="small" fullWidth={true}>
                                {/* <Select
                                    name="brandCd"
                                    value={modify.brandCd}
                                    onChange={onBrandChage}
                                >
                                    {brands.map((map)=>(
                                        <MenuItem key={map.cd} value={map.cd}>
                                            {map.name}
                                        </MenuItem>
                                    ))}
                                </Select> */}
                                <USelectBox
                                    id="brandCd"
                                    name="brandCd"
                                    items={storeNo}
                                    onItemChange={onBrandChage}
                                    defaultValue={select.brandCd}
                                />
                            </FormControl>
                            }
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                        <TableCell className="table-cell">
                            <FormControlLabel
                                sx={{mb:0, mt:0 }}
                                control={
                                    <Checkbox
                                    name="useYn"
                                    checked={modify.useYn == "N" ? false : true}
                                    onChange={e => onCheckboxChange(e)}
                                    />
                                }
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell className="table-cell-title">{fni18n('사원번호')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                    fullWidth={true}
                                    size="small"
                                    name="userId"
                                    value={modify.userId||""}
                                    required
                                    InputProps={{
                                        readOnly: modify.create,
                                    }}
                                    onChange={onParamsChange}
                                    disabled={modify.create}
                                    variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('사원명')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                    fullWidth={true}
                                    size="small"
                                    name="userNm"
                                    value={modify.userNm||""}
                                    required
                                    onChange={onParamsChange}
                                    variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('유효기간')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth={true}
                                size="small"
                                name="useSetupDt"
                                value={modify.useSetupDt}
                                // disabled
                                InputProps={{
                                    readOnly: false,
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="table-cell-title">{fni18n('사용자그룹')}</TableCell>
                        <TableCell className="table-cell">
                            <FormControl size="small" fullWidth={true}>
                            <Select
                                name="grpNm"
                                value={modify.grpNm}
                                onChange={onGroupChage}
                            >
                                {groups.map((map)=>(
                                    <MenuItem key={map.name} value={map.name}>
                                        {map.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('1일출금한도')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth={true}
                                size="small"
                                name="tranctAmt"
                                value={total.dayLimtAmt||0}
                                disabled
                                InputProps={{
                                    readOnly: true,
                                    inputProps: {style:{textAlign:"right"}},
                                    startAdornment:<InputAdornment position="start">$</InputAdornment>,
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('1회출금한도')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth={true}
                                size="small"
                                name="tranctAmt"
                                value={total.tranctAmt||0}
                                disabled
                                InputProps={{
                                    readOnly: true,
                                    inputProps: {style:{textAlign:"right"}},
                                    startAdornment:<InputAdornment position="start">$</InputAdornment>,
                                }}
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                    </TableRow>
                    {/* <TableRow>
                        <TableCell className="table-cell-title">{fni18n('비밀번호초기화')}</TableCell>
                        <TableCell className="table-cell" >
                            <Button 
                                style={{ width: "100%", height: "100%",}}
                                variant="contained"
                                color="secondary"
                                onClick={e =>onPwdChange(e)}
                                disabled={!modify.create}
                            >
                                {fni18n('변경')}
                            </Button>
                        </TableCell>
                        <TableCell className="table-cell"></TableCell>
                        <TableCell className="table-cell"></TableCell>
                        <TableCell className="table-cell"></TableCell>
                        <TableCell className="table-cell"></TableCell>
                        </TableRow> */}
                    </TableBody>
                </Table>
            </TableContainer>
            </div>
        </div>
    );
}

export default UserModify;
